const Tags = {
  Foes: [
    {
      Name: "Broken",
      Tags: [
        "marine",
        "pass",
        "shadowfen",
        "subterranean",
        "tanglewood",
        "corrupted",
        "sentient",
        "squatter",
        "plains",
        "wastes",
      ],
      id: "core-foe-ironlander-broken",
      Type: "Ironlander",
    },
    {
      Name: "Common Folk",
      Tags: ["sentient", "squatter"],
      id: "core-foe-ironlander-common-folk",
      Type: "Ironlander",
    },
    {
      Name: "Hunter",
      Tags: ["marine", "pass", "shadowfen", "tanglewood", "wild", "sentient", "squatter", "plains", "wastes"],
      id: "core-foe-ironlander-hunter",
      Type: "Ironlander",
    },
    {
      Name: "Mystic",
      Tags: [
        "marine",
        "pass",
        "shadowfen",
        "subterranean",
        "tanglewood",
        "corrupted",
        "faithful",
        "remnant",
        "sentient",
        "squatter",
        "plains",
        "wastes",
      ],
      id: "core-foe-ironlander-mystic",
      Type: "Ironlander",
    },
    {
      Name: "Raider",
      Tags: ["marine", "pass", "shadowfen", "subterranean", "tanglewood", "sentient", "squatter", "plains", "wastes"],
      id: "core-foe-ironlander-raider",
      Type: "Ironlander",
    },
    {
      Name: "Warrior",
      Tags: ["marine", "pass", "shadowfen", "subterranean", "tanglewood", "faithful", "sentient", "plains", "wastes"],
      id: "core-foe-ironlander-warrior",
      Type: "Ironlander",
    },
    {
      Name: "Husk",
      Tags: [
        "marine",
        "pass",
        "shadowfen",
        "subterranean",
        "tanglewood",
        "corrupted",
        "sentient",
        "squatter",
        "plains",
        "wastes",
      ],
      id: "core-foe-ironlander-husk",
      Type: "Ironlander",
    },
    {
      Name: "Zealot",
      Tags: [
        "marine",
        "pass",
        "shadowfen",
        "subterranean",
        "tanglewood",
        "faithful",
        "remnant",
        "sentient",
        "squatter",
        "plains",
        "wastes",
      ],
      id: "core-foe-ironlander-zealot",
      Type: "Ironlander",
    },
    {
      Name: "Elf",
      Tags: ["tanglewood", "wild", "sentient"],
      id: "core-foe-firstborn-elf",
      Type: "Firstborn",
    },
    {
      Name: "Giant",
      Tags: ["pass", "wild", "sentient", "wastes"],
      id: "core-foe-firstborn-giant",
      Type: "Firstborn",
    },
    {
      Name: "Primordial",
      Tags: ["arctic", "marine", "pass", "shadowfen", "tanglewood", "wild", "flying", "plains", "wastes"],
      id: "core-foe-firstborn-primordial",
      Type: "Firstborn",
    },
    {
      Name: "Troll",
      Tags: ["shadowfen", "wild", "sentient", "DEVEL_freshwater"],
      id: "core-foe-firstborn-troll",
      Type: "Firstborn",
    },
    {
      Name: "Varou",
      Tags: ["tanglewood", "wild", "sentient"],
      id: "core-foe-firstborn-varou",
      Type: "Firstborn",
    },
    {
      Name: "Atanya",
      Tags: ["arctic", "marine", "wild", "sentient"],
      id: "core-foe-firstborn-atanya",
      Type: "Firstborn",
    },
    {
      Name: "Merrow",
      Tags: ["marine", "shadowfen", "faithful", "wild", "remnant", "sentient"],
      id: "core-foe-firstborn-merrow",
      Type: "Firstborn",
    },
    {
      Name: "Bear",
      Tags: ["arctic", "pass", "shadowfen", "tanglewood", "wild", "squatter", "plains", "wastes"],
      id: "core-foe-animal-bear",
      Type: "Animal",
    },
    {
      Name: "Boar",
      Tags: ["shadowfen", "tanglewood", "wild", "squatter", "plains"],
      id: "core-foe-animal-boar",
      Type: "Animal",
    },
    {
      Name: "Gaunt",
      Tags: ["tanglewood", "wild"],
      id: "core-foe-animal-gaunt",
      Type: "Animal",
    },
    {
      Name: "Marsh Rat",
      Tags: ["shadowfen", "vermin", "wild"],
      id: "core-foe-animal-marsh-rat",
      Type: "Animal",
    },
    {
      Name: "Wolf",
      Tags: ["arctic", "pass", "shadowfen", "tanglewood", "wild", "squatter", "plains", "wastes"],
      id: "core-foe-animal-wolf",
      Type: "Animal",
    },
    {
      Name: "Bladewing",
      Tags: ["pass", "shadowfen", "subterranean", "vermin", "wild", "squatter", "flying", "plains", "wastes"],
      id: "core-foe-animal-bladewing",
      Type: "Animal",
    },
    {
      Name: "Carrion Newt",
      Tags: ["shadowfen", "subterranean", "vermin", "wild", "DEVEL_freshwater"],
      id: "core-foe-animal-carrion-newt",
      Type: "Animal",
    },
    {
      Name: "Cave Lion",
      Tags: ["pass", "subterranean", "tanglewood", "wild", "squatter", "wastes"],
      id: "core-foe-animal-cave-lion",
      Type: "Animal",
    },
    {
      Name: "Deep Rat",
      Tags: ["subterranean", "vermin", "wild", "squatter"],
      id: "core-foe-animal-deep-rat",
      Type: "Animal",
    },
    {
      Name: "Nightmare Spider",
      Tags: ["subterranean", "tanglewood", "vermin", "wild", "squatter"],
      id: "core-foe-animal-nightmare-spider",
      Type: "Animal",
    },
    {
      Name: "Shroud Crab",
      Tags: ["marine", "vermin", "wild"],
      id: "core-foe-animal-shroud-crab",
      Type: "Animal",
    },
    {
      Name: "Trog",
      Tags: ["subterranean", "vermin", "wild"],
      id: "core-foe-animal-trog",
      Type: "Animal",
    },
    {
      Name: "Basilisk",
      Tags: ["shadowfen", "vermin", "wild", "DEVEL_freshwater"],
      id: "core-foe-beast-basilisk",
      Type: "Beast",
    },
    {
      Name: "Elder Beast",
      Tags: ["arctic", "marine", "pass", "shadowfen", "subterranean", "tanglewood", "wild", "flying", "plains"],
      id: "core-foe-beast-elder-beast",
      Type: "Beast",
    },
    {
      Name: "Harrow Spider",
      Tags: ["tanglewood", "vermin", "wild"],
      id: "core-foe-beast-harrow-spider",
      Type: "Beast",
    },
    {
      Name: "Leviathan",
      Tags: ["marine", "wild"],
      id: "core-foe-beast-leviathan",
      Type: "Beast",
    },
    {
      Name: "Mammoth",
      Tags: ["wild", "plains", "wastes"],
      id: "core-foe-beast-mammoth",
      Type: "Beast",
    },
    {
      Name: "Wyvern",
      Tags: ["marine", "pass", "tanglewood", "vermin", "wild", "flying", "plains", "wastes"],
      id: "core-foe-beast-wyvern",
      Type: "Beast",
    },
    {
      Name: "Chitter",
      Tags: ["subterranean", "vermin", "wild", "squatter"],
      id: "core-foe-beast-chitter",
      Type: "Beast",
    },
    {
      Name: "Gnarl",
      Tags: ["tanglewood", "wild"],
      id: "core-foe-beast-gnarl",
      Type: "Beast",
    },
    {
      Name: "Iron-Wracked Beast",
      Tags: [
        "arctic",
        "marine",
        "pass",
        "shadowfen",
        "subterranean",
        "tanglewood",
        "vermin",
        "corrupted",
        "wild",
        "flying",
        "plains",
        "wastes",
      ],
      id: "core-foe-beast-iron-wracked-beast",
      Type: "Beast",
    },
    {
      Name: "Kraken",
      Tags: ["marine", "wild"],
      id: "core-foe-beast-kraken",
      Type: "Beast",
    },
    {
      Name: "Nightspawn",
      Tags: [
        "arctic",
        "marine",
        "pass",
        "shadowfen",
        "subterranean",
        "tanglewood",
        "vermin",
        "corrupted",
        "faithful",
        "wild",
        "remnant",
        "squatter",
        "flying",
        "plains",
        "wastes",
      ],
      id: "core-foe-beast-nightspawn",
      Type: "Beast",
    },
    {
      Name: "Rhaskar",
      Tags: ["arctic", "marine", "wild"],
      id: "core-foe-beast-rhaskar",
      Type: "Beast",
    },
    {
      Name: "Wyrm",
      Tags: ["subterranean", "tanglewood", "wild"],
      id: "core-foe-beast-wyrm",
      Type: "Beast",
    },
    {
      Name: "Bonewalker",
      Tags: ["arctic", "pass", "shadowfen", "subterranean", "tanglewood", "corrupted", "undead", "plains", "wastes"],
      id: "core-foe-horror-bonewalker",
      Type: "Horror",
    },
    {
      Name: "Frostbound",
      Tags: ["arctic", "pass", "remnant", "undead", "wastes"],
      id: "core-foe-horror-frostbound",
      Type: "Horror",
    },
    {
      Name: "Chimera",
      Tags: [
        "arctic",
        "marine",
        "pass",
        "shadowfen",
        "subterranean",
        "tanglewood",
        "vermin",
        "corrupted",
        "flying",
        "plains",
        "wastes",
      ],
      id: "core-foe-horror-chimera",
      Type: "Horror",
    },
    {
      Name: "Haunt",
      Tags: [
        "arctic",
        "marine",
        "pass",
        "shadowfen",
        "subterranean",
        "tanglewood",
        "remnant",
        "sentient",
        "squatter",
        "undead",
        "plains",
        "wastes",
      ],
      id: "core-foe-horror-haunt",
      Type: "Horror",
    },
    {
      Name: "Hollow",
      Tags: ["tanglewood", "wild", "sentient", "undead"],
      id: "core-foe-horror-hollow",
      Type: "Horror",
    },
    {
      Name: "Iron Revenant",
      Tags: [
        "arctic",
        "marine",
        "pass",
        "shadowfen",
        "subterranean",
        "tanglewood",
        "faithful",
        "remnant",
        "sentient",
        "undead",
        "plains",
        "wastes",
      ],
      id: "core-foe-horror-iron-revenant",
      Type: "Horror",
    },
    {
      Name: "Sodden",
      Tags: ["marine", "shadowfen", "remnant", "sentient", "undead", "DEVEL_freshwater"],
      id: "core-foe-horror-sodden",
      Type: "Horror",
    },
    {
      Name: "Blighthound",
      Tags: ["arctic", "pass", "shadowfen", "subterranean", "tanglewood", "corrupted", "plains", "wastes"],
      id: "core-foe-horror-blighthound",
      Type: "Horror",
    },
    {
      Name: "Bog Rot",
      Tags: ["shadowfen", "corrupted", "remnant", "sentient", "undead"],
      id: "core-foe-horror-bog-rot",
      Type: "Horror",
    },
    {
      Name: "Bonehorde",
      Tags: ["pass", "shadowfen", "subterranean", "tanglewood", "corrupted", "remnant", "undead", "plains", "wastes"],
      id: "core-foe-horror-bonehorde",
      Type: "Horror",
    },
    {
      Name: "Thrall",
      Tags: [
        "marine",
        "pass",
        "shadowfen",
        "subterranean",
        "tanglewood",
        "remnant",
        "sentient",
        "squatter",
        "undead",
        "plains",
        "wastes",
      ],
      id: "core-foe-horror-thrall",
      Type: "Horror",
    },
    {
      Name: "Wight",
      Tags: [
        "arctic",
        "marine",
        "pass",
        "shadowfen",
        "subterranean",
        "tanglewood",
        "faithful",
        "remnant",
        "sentient",
        "squatter",
        "undead",
        "plains",
        "wastes",
      ],
      id: "core-foe-horror-wight",
      Type: "Horror",
    },
    {
      Name: "Blood Thorn",
      Tags: ["tanglewood", "wild", "immobile"],
      id: "core-foe-anomaly-blood-thorn",
      Type: "Anomaly",
    },
    {
      Name: "Circle of Stones",
      Tags: ["pass", "shadowfen", "tanglewood", "remnant", "sentient", "immobile", "plains", "wastes"],
      id: "core-foe-anomaly-circle-of stones",
      Type: "Anomaly",
    },
    {
      Name: "Glimmer",
      Tags: [
        "arctic",
        "marine",
        "pass",
        "shadowfen",
        "subterranean",
        "tanglewood",
        "corrupted",
        "sentient",
        "plains",
        "wastes",
      ],
      id: "core-foe-anomaly-glimmer",
      Type: "Anomaly",
    },
    {
      Name: "Gloom",
      Tags: ["shadowfen", "subterranean", "tanglewood", "corrupted", "flying"],
      id: "core-foe-anomaly-gloom",
      Type: "Anomaly",
    },
    {
      Name: "Maelstrom",
      Tags: ["marine", "subterranean", "wild", "remnant"],
      id: "core-foe-anomaly-maelstrom",
      Type: "Anomaly",
    },
    {
      Name: "Tempest",
      Tags: ["arctic", "marine", "pass", "shadowfen", "tanglewood", "flying", "plains", "wastes"],
      id: "core-foe-anomaly-tempest",
      Type: "Anomaly",
    },
  ],
  DelveCards: [
    {
      id: "core-theme-ancient",
      Type: "Theme",
      Name: "Ancient",
      Tags: ["remnant", "squatter"],
    },
    {
      id: "core-theme-corrupted",
      Type: "Theme",
      Name: "Corrupted",
      Tags: ["corrupted"],
    },
    {
      id: "core-theme-fortified",
      Type: "Theme",
      Name: "Fortified",
      Tags: ["sentient"],
    },
    {
      id: "core-theme-hallowed",
      Type: "Theme",
      Name: "Hallowed",
      Tags: ["faithful"],
    },
    {
      id: "core-theme-haunted",
      Type: "Theme",
      Name: "Haunted",
      Tags: ["remnant", "undead"],
    },
    {
      id: "core-theme-infested",
      Type: "Theme",
      Name: "Infested",
      Tags: ["vermin"],
    },
    {
      id: "core-theme-ravaged",
      Type: "Theme",
      Name: "Ravaged",
      Tags: ["remnant", "squatter"],
    },
    {
      id: "core-theme-wild",
      Type: "Theme",
      Name: "Wild",
      Tags: ["wild", "squatter"],
    },
    {
      id: "core-domain-barrow",
      Type: "Domain",
      Name: "Barrow",
      Tags: ["faithful", "subterranean", "undead"],
    },
    {
      id: "core-domain-cavern",
      Type: "Domain",
      Name: "Cavern",
      Tags: ["subterranean"],
    },
    {
      id: "core-domain-frozen-cavern",
      Type: "Domain",
      Name: "Frozen Cavern",
      Tags: ["arctic", "subterranean"],
    },
    {
      id: "core-domain-ice-reach",
      Type: "Domain",
      Name: "Ice Reach",
      Tags: ["arctic", "marine"],
    },
    {
      id: "core-domain-mine",
      Type: "Domain",
      Name: "Mine",
      Tags: ["subterranean", "sentient"],
    },
    {
      id: "core-domain-pass",
      Type: "Domain",
      Name: "Pass",
      Tags: ["pass"],
    },
    {
      id: "core-domain-ruin",
      Type: "Domain",
      Name: "Ruin",
      Tags: ["remnant", "sentient", "squatter"],
    },
    {
      id: "core-domain-sea-cave",
      Type: "Domain",
      Name: "Sea Cave",
      Tags: ["marine"],
    },
    {
      id: "core-domain-shadowfen",
      Type: "Domain",
      Name: "Shadowfen",
      Tags: ["shadowfen"],
    },
    {
      id: "core-domain-stronghold",
      Type: "Domain",
      Name: "Stronghold",
      Tags: ["sentient"],
    },
    {
      id: "core-domain-tanglewood",
      Type: "Domain",
      Name: "Tanglewood",
      Tags: ["tanglewood"],
    },
    {
      id: "core-domain-underkeep",
      Type: "Domain",
      Name: "Underkeep",
      Tags: ["remnant", "sentient", "subterranean"],
    },
  ],
};

export default Tags;
